import { render, staticRenderFns } from "./supportForm.vue?vue&type=template&id=79a9f442&scoped=true"
import script from "./supportForm.vue?vue&type=script&lang=js"
export * from "./supportForm.vue?vue&type=script&lang=js"
import style0 from "./supportForm.vue?vue&type=style&index=0&id=79a9f442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9f442",
  null
  
)

export default component.exports